import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Http } from '@angular/http';
import { RequestBuilder } from '../classes/request-builder';
import { Observable } from 'rxjs';
import * as Enum from '../utils/enums'

@Injectable({
  providedIn: 'root'
})
export class AggiudicatarioService extends BaseService {
  /**
     * Costruttore
     * @param http Servizio di richieste HTTP 
     */
  constructor(http: Http) {
    super(http);
  }

  /**
   * get all aggiudicatari
   * @param reqBuilder data
   */
  getAllAggiudicatari(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('aggiudicatario/fetch', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * create or update aggiudicatario
   * create if ID is null 
   * Update if ID is not null
   */
  save(reqBuilder: RequestBuilder): Observable<any> {
    return this.doPost('aggiudicatario/save', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }
}